import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import contactLists from './modules/contactLists'
import contacts from './modules/contacts'
import persons from './modules/persons'
import search from './modules/search'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        user,
        auth,
        contactLists,
        contacts,
        persons,
        search,
    },
    strict: debug,
})